webpackJsonp([199248266171276],{

/***/ 216:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	function isElement(el) {
	  return el != null && typeof el === 'object' && (el.nodeType === 1 || el.nodeType === 11);
	}
	
	function canOverflow(overflow, skipOverflowHiddenElements) {
	  if (skipOverflowHiddenElements && overflow === 'hidden') {
	    return false;
	  }
	
	  return overflow !== 'visible' && overflow !== 'clip';
	}
	
	function isScrollable(el, skipOverflowHiddenElements) {
	  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
	    var style = getComputedStyle(el, null);
	    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements);
	  }
	
	  return false;
	}
	
	function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
	  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
	    return 0;
	  }
	
	  if (elementEdgeStart < scrollingEdgeStart && elementSize < scrollingSize || elementEdgeEnd > scrollingEdgeEnd && elementSize > scrollingSize) {
	    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
	  }
	
	  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
	    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
	  }
	
	  return 0;
	}
	
	var _default = function _default(target, options) {
	  var scrollMode = options.scrollMode,
	      block = options.block,
	      inline = options.inline,
	      boundary = options.boundary,
	      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
	  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
	    return node !== boundary;
	  };
	
	  if (!isElement(target)) {
	    throw new TypeError('Invalid target');
	  }
	
	  var scrollingElement = document.scrollingElement || document.documentElement;
	  var frames = [];
	  var cursor = target;
	
	  while (isElement(cursor) && checkBoundary(cursor)) {
	    cursor = cursor.parentNode || cursor.host;
	
	    if (cursor === scrollingElement) {
	      frames.push(cursor);
	      break;
	    }
	
	    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
	      continue;
	    }
	
	    if (isScrollable(cursor, skipOverflowHiddenElements)) {
	      frames.push(cursor);
	    }
	  }
	
	  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
	  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
	  var viewportX = window.scrollX || pageXOffset;
	  var viewportY = window.scrollY || pageYOffset;
	
	  var _target$getBoundingCl = target.getBoundingClientRect(),
	      targetHeight = _target$getBoundingCl.height,
	      targetWidth = _target$getBoundingCl.width,
	      targetTop = _target$getBoundingCl.top,
	      targetRight = _target$getBoundingCl.right,
	      targetBottom = _target$getBoundingCl.bottom,
	      targetLeft = _target$getBoundingCl.left;
	
	  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
	  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
	  var computations = [];
	
	  for (var index = 0; index < frames.length; index++) {
	    var frame = frames[index];
	
	    var _frame$getBoundingCli = frame.getBoundingClientRect(),
	        _height = _frame$getBoundingCli.height,
	        _width = _frame$getBoundingCli.width,
	        _top = _frame$getBoundingCli.top,
	        right = _frame$getBoundingCli.right,
	        bottom = _frame$getBoundingCli.bottom,
	        _left = _frame$getBoundingCli.left;
	
	    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) {
	      return computations;
	    }
	
	    var frameStyle = getComputedStyle(frame);
	    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
	    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
	    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
	    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
	    var blockScroll = 0;
	    var inlineScroll = 0;
	    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
	    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;
	
	    if (scrollingElement === frame) {
	      if (block === 'start') {
	        blockScroll = targetBlock;
	      } else if (block === 'end') {
	        blockScroll = targetBlock - viewportHeight;
	      } else if (block === 'nearest') {
	        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
	      } else {
	        blockScroll = targetBlock - viewportHeight / 2;
	      }
	
	      if (inline === 'start') {
	        inlineScroll = targetInline;
	      } else if (inline === 'center') {
	        inlineScroll = targetInline - viewportWidth / 2;
	      } else if (inline === 'end') {
	        inlineScroll = targetInline - viewportWidth;
	      } else {
	        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
	      }
	
	      blockScroll = Math.max(0, blockScroll + viewportY);
	      inlineScroll = Math.max(0, inlineScroll + viewportX);
	    } else {
	      if (block === 'start') {
	        blockScroll = targetBlock - _top - borderTop;
	      } else if (block === 'end') {
	        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
	      } else if (block === 'nearest') {
	        blockScroll = alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
	      } else {
	        blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
	      }
	
	      if (inline === 'start') {
	        inlineScroll = targetInline - _left - borderLeft;
	      } else if (inline === 'center') {
	        inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
	      } else if (inline === 'end') {
	        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
	      } else {
	        inlineScroll = alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
	      }
	
	      var scrollLeft = frame.scrollLeft,
	          scrollTop = frame.scrollTop;
	      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
	      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
	      targetBlock += scrollTop - blockScroll;
	      targetInline += scrollLeft - inlineScroll;
	    }
	
	    computations.push({
	      el: frame,
	      top: blockScroll,
	      left: inlineScroll
	    });
	  }
	
	  return computations;
	};
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _computeScrollIntoView = _interopRequireDefault(__webpack_require__(216));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isOptionsObject(options) {
	  return options === Object(options) && Object.keys(options).length !== 0;
	}
	
	function defaultBehavior(actions, behavior) {
	  if (behavior === void 0) {
	    behavior = 'auto';
	  }
	
	  var canSmoothScroll = 'scrollBehavior' in document.body.style;
	  actions.forEach(function (_ref) {
	    var el = _ref.el,
	        top = _ref.top,
	        left = _ref.left;
	
	    if (el.scroll && canSmoothScroll) {
	      el.scroll({
	        top: top,
	        left: left,
	        behavior: behavior
	      });
	    } else {
	      el.scrollTop = top;
	      el.scrollLeft = left;
	    }
	  });
	}
	
	function getOptions(options) {
	  if (options === false) {
	    return {
	      block: 'end',
	      inline: 'nearest'
	    };
	  }
	
	  if (isOptionsObject(options)) {
	    return options;
	  }
	
	  return {
	    block: 'start',
	    inline: 'nearest'
	  };
	}
	
	function scrollIntoView(target, options) {
	  if (isOptionsObject(options) && typeof options.behavior === 'function') {
	    return options.behavior((0, _computeScrollIntoView.default)(target, options));
	  }
	
	  var computeOptions = getOptions(options);
	  return defaultBehavior((0, _computeScrollIntoView.default)(target, computeOptions), computeOptions.behavior);
	}
	
	var _default = scrollIntoView;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"src-components-button----button-module---button---38F6g"};

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactGa = __webpack_require__(24);
	
	var _reactFontawesome = __webpack_require__(11);
	
	var _buttonModule = __webpack_require__(109);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(_ref) {
	  var to = _ref.to,
	      text = _ref.text,
	      useArrow = _ref.useArrow,
	      outBound = _ref.outBound;
	
	  var button = outBound ? _react2.default.createElement(
	    _reactGa.OutboundLink,
	    {
	      to: to,
	      eventLabel: to,
	      className: (0, _classnames2.default)('buttonNormal', _buttonModule2.default.button)
	    },
	    text,
	    useArrow && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'arrow-right'] })
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: to, className: (0, _classnames2.default)('buttonNormal', _buttonModule2.default.button) },
	    text,
	    useArrow && _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'arrow-right'] })
	  );
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    button
	  );
	};
	
	Button.propTypes = {
	  to: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  useArrow: _propTypes2.default.bool,
	  outBound: _propTypes2.default.bool
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _imageWrapper = __webpack_require__(20);
	
	var _imageWrapper2 = _interopRequireDefault(_imageWrapper);
	
	var _helperFunctions = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Images = function (_Component) {
	  _inherits(Images, _Component);
	
	  function Images(props) {
	    _classCallCheck(this, Images);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      desktop: true,
	      tablet: false,
	      mobile: false
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  Images.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.handleResize);
	    this.handleResize();
	  };
	
	  Images.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.handleResize);
	  };
	
	  Images.prototype.handleResize = function handleResize() {
	    if (window.innerWidth < 768) {
	      this.setState({
	        desktop: false,
	        tablet: false,
	        mobile: true
	      });
	    } else if (window.innerWidth < 1173) {
	      this.setState({
	        desktop: false,
	        tablet: true,
	        mobile: false
	      });
	    } else {
	      this.setState({
	        desktop: true,
	        tablet: false,
	        mobile: false
	      });
	    }
	  };
	
	  Images.prototype.render = function render() {
	    var _props = this.props,
	        alt = _props.alt,
	        outerWrapperClassName = _props.outerWrapperClassName,
	        desktopSrc = _props.desktopSrc,
	        tabletSrc = _props.tabletSrc,
	        mobileSrc = _props.mobileSrc,
	        sizes = _props.sizes;
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      this.state.desktop && _react2.default.createElement(_imageWrapper2.default, {
	        src: desktopSrc,
	        alt: alt,
	        sizes: (0, _helperFunctions.findImageSizes)(desktopSrc, sizes),
	        outerWrapperClassName: outerWrapperClassName
	      }),
	      this.state.tablet && _react2.default.createElement(_imageWrapper2.default, {
	        src: tabletSrc,
	        alt: alt,
	        sizes: (0, _helperFunctions.findImageSizes)(tabletSrc, sizes),
	        outerWrapperClassName: outerWrapperClassName
	      }),
	      this.state.mobile && _react2.default.createElement(_imageWrapper2.default, {
	        src: mobileSrc,
	        alt: alt,
	        sizes: (0, _helperFunctions.findImageSizes)(mobileSrc, sizes),
	        outerWrapperClassName: outerWrapperClassName
	      })
	    );
	  };
	
	  return Images;
	}(_react.Component);
	
	Images.propTypes = {
	  alt: _propTypes2.default.string,
	  outerWrapperClassName: _propTypes2.default.string,
	  desktopSrc: _propTypes2.default.string,
	  tabletSrc: _propTypes2.default.string,
	  mobileSrc: _propTypes2.default.string,
	  sizes: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	exports.default = Images;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactFontawesome = __webpack_require__(11);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _linkCardModule = __webpack_require__(288);
	
	var _linkCardModule2 = _interopRequireDefault(_linkCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkCard = function LinkCard(_ref) {
	  var _classNames;
	
	  var header = _ref.header,
	      id = _ref.id,
	      description = _ref.description,
	      isDark = _ref.isDark,
	      icon = _ref.icon,
	      onClickFunction = _ref.onClickFunction,
	      linkText = _ref.linkText;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(_linkCardModule2.default.linkCard, (_classNames = {}, _classNames[_linkCardModule2.default.dark] = isDark, _classNames))
	    },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '#' + id, onClick: function onClick(event) {
	          return onClickFunction(event, id);
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: _linkCardModule2.default.header },
	        _react2.default.createElement(
	          'div',
	          { className: _linkCardModule2.default.iconWrapper },
	          _react2.default.createElement(
	            'div',
	            { className: _linkCardModule2.default.icon },
	            _react2.default.createElement('img', { src: icon.desktop, alt: header })
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          header
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        description
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('textButton', _linkCardModule2.default.link) },
	        linkText,
	        ' ',
	        id === 'infront' ? _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: ['fas', 'external-link-alt'] }) : ''
	      )
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        className: (0, _classnames2.default)('textButton', _linkCardModule2.default.mobileLink),
	        to: '#' + id,
	        onClick: function onClick(event) {
	          return onClickFunction(event, id);
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _linkCardModule2.default.iconWrapper },
	        _react2.default.createElement(
	          'div',
	          { className: _linkCardModule2.default.icon },
	          _react2.default.createElement('img', { src: icon.mobile, alt: header })
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        { className: 'linkCardTitle' },
	        header
	      )
	    )
	  );
	};
	
	exports.default = LinkCard;
	
	
	LinkCard.propTypes = {
	  header: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  linkText: _propTypes2.default.string,
	  isDark: _propTypes2.default.bool,
	  icon: _propTypes2.default.shape({
	    mobile: _propTypes2.default.string,
	    desktop: _propTypes2.default.string
	  }),
	  onClickFunction: _propTypes2.default.func
	};
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"linkCard":"src-components-linkCard----linkCard-module---linkCard---2KxwL","header":"src-components-linkCard----linkCard-module---header---eNrXt","icon":"src-components-linkCard----linkCard-module---icon---3hxXy","iconWrapper":"src-components-linkCard----linkCard-module---iconWrapper---1wMAl","link":"src-components-linkCard----linkCard-module---link---325qi","mobileLink":"src-components-linkCard----linkCard-module---mobileLink---3KNvZ","dark":"src-components-linkCard----linkCard-module---dark---2bNZI"};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sectionHeaderModule = __webpack_require__(291);
	
	var _sectionHeaderModule2 = _interopRequireDefault(_sectionHeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionHeader = function SectionHeader(_ref) {
	  var header = _ref.header,
	      subHeader = _ref.subHeader,
	      text = _ref.text;
	  return _react2.default.createElement(
	    'section',
	    { className: _sectionHeaderModule2.default.sectionHeader },
	    _react2.default.createElement(
	      'h1',
	      null,
	      header
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'subtitle' },
	      subHeader
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'bodyLarge' },
	      text
	    )
	  );
	};
	
	SectionHeader.propTypes = {
	  header: _propTypes2.default.string,
	  subHeader: _propTypes2.default.string,
	  text: _propTypes2.default.string
	};
	
	exports.default = SectionHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sectionHeader":"src-components-sectionHeader----sectionHeader-module---sectionHeader---17JM6"};

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helperFunctions = __webpack_require__(25);
	
	var _imageWrapper = __webpack_require__(20);
	
	var _imageWrapper2 = _interopRequireDefault(_imageWrapper);
	
	var _serviceIntegrationsModule = __webpack_require__(110);
	
	var _serviceIntegrationsModule2 = _interopRequireDefault(_serviceIntegrationsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceIntegrations = function ServiceIntegrations(_ref) {
	  var header = _ref.header,
	      text = _ref.text,
	      logos = _ref.logos,
	      imageSizes = _ref.imageSizes;
	  return _react2.default.createElement(
	    'section',
	    { className: _serviceIntegrationsModule2.default.serviceIntegrations },
	    _react2.default.createElement(
	      'h2',
	      null,
	      header
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      text
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _serviceIntegrationsModule2.default.integrationLogos },
	      logos && logos.map(function (logo) {
	        return _react2.default.createElement(_imageWrapper2.default, {
	          key: logo.name,
	          src: logo.logo,
	          alt: logo.name,
	          sizes: (0, _helperFunctions.findImageSizes)(logo.logo, imageSizes),
	          outerWrapperClassName: _serviceIntegrationsModule2.default.imageContainer
	        });
	      })
	    )
	  );
	};
	
	exports.default = ServiceIntegrations;
	
	
	ServiceIntegrations.propTypes = {
	  header: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  logos: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  imageSizes: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"serviceIntegrations":"src-components-serviceIntegrations----serviceIntegrations-module---serviceIntegrations---2qoEX","integrationLogos":"src-components-serviceIntegrations----serviceIntegrations-module---integrationLogos---1EPVC","imageContainer":"src-components-serviceIntegrations----serviceIntegrations-module---imageContainer---RjdBK"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.productPageQuery = exports.ProductPageTemplate = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scrollIntoViewIfNeeded = __webpack_require__(354);
	
	var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);
	
	var _productPageModule = __webpack_require__(296);
	
	var _productPageModule2 = _interopRequireDefault(_productPageModule);
	
	var _index = __webpack_require__(201);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(74);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _linkCard = __webpack_require__(199);
	
	var _linkCard2 = _interopRequireDefault(_linkCard);
	
	var _index5 = __webpack_require__(76);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _images = __webpack_require__(75);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductPageTemplate = exports.ProductPageTemplate = function (_Component) {
	  _inherits(ProductPageTemplate, _Component);
	
	  function ProductPageTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProductPageTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.scrollToRef = function (event, ref) {
	      event.preventDefault();
	      if (ref === 'infront') {
	        window.location.assign('https://www.infrontfinance.com/');
	      } else {
	        (0, _scrollIntoViewIfNeeded2.default)(_this[ref], {
	          behavior: 'smooth',
	          scrollMode: 'always',
	          block: 'start',
	          inline: 'start'
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProductPageTemplate.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        linkCardsSection = _props.linkCardsSection,
	        investorPortal = _props.investorPortal,
	        standardProducts = _props.standardProducts,
	        services = _props.services,
	        imageSizes = _props.imageSizes;
	
	
	    return _react2.default.createElement(
	      'main',
	      { className: _productPageModule2.default.productPage },
	      _react2.default.createElement(
	        'section',
	        { className: _productPageModule2.default.linkCardsSection },
	        _react2.default.createElement(
	          'h1',
	          { className: _productPageModule2.default.centered },
	          linkCardsSection.title
	        ),
	        _react2.default.createElement(
	          'nav',
	          { className: _productPageModule2.default.linkCards },
	          linkCardsSection.linkCards && linkCardsSection.linkCards.map(function (linkCard) {
	            return _react2.default.createElement(_linkCard2.default, {
	              key: linkCard.header,
	              icon: linkCard.icon,
	              id: linkCard.id,
	              header: linkCard.header,
	              description: linkCard.description,
	              isDark: linkCard.isDark,
	              linkText: linkCard.linkText,
	              onClickFunction: _this2.scrollToRef
	            });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        {
	          className: _productPageModule2.default.investorPortal,
	          id: investorPortal.id,
	          ref: function ref(investorPortalSection) {
	            _this2[investorPortal.id] = investorPortalSection;
	          }
	        },
	        _react2.default.createElement(_index2.default, {
	          header: investorPortal.sectionHeader.header,
	          subHeader: investorPortal.sectionHeader.subHeader,
	          text: investorPortal.sectionHeader.text
	        }),
	        _react2.default.createElement(
	          'section',
	          { className: _productPageModule2.default.onlinePortfolio },
	          _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)('overline', _productPageModule2.default.overline) },
	            investorPortal.onlinePortfolio.overline
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            investorPortal.onlinePortfolio.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            investorPortal.onlinePortfolio.text
	          ),
	          _react2.default.createElement(_images2.default, {
	            alt: investorPortal.onlinePortfolio.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: investorPortal.onlinePortfolio.desktopImage,
	            tabletSrc: investorPortal.onlinePortfolio.tabletImage,
	            mobileSrc: investorPortal.onlinePortfolio.mobileImage,
	            sizes: imageSizes
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: _productPageModule2.default.trading },
	          _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)('overline', _productPageModule2.default.overline) },
	            investorPortal.trading.overline
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            investorPortal.trading.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            investorPortal.trading.text
	          ),
	          _react2.default.createElement(_images2.default, {
	            alt: investorPortal.trading.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: investorPortal.trading.desktopImage,
	            tabletSrc: investorPortal.trading.tabletImage,
	            mobileSrc: investorPortal.trading.mobileImage,
	            sizes: imageSizes
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: _productPageModule2.default.marketData },
	          _react2.default.createElement(
	            'p',
	            { className: (0, _classnames2.default)('overline', _productPageModule2.default.overline) },
	            investorPortal.marketData.overline
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            investorPortal.marketData.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            investorPortal.marketData.text
	          ),
	          _react2.default.createElement(_images2.default, {
	            alt: investorPortal.marketData.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: investorPortal.marketData.desktopImage,
	            tabletSrc: investorPortal.marketData.tabletImage,
	            mobileSrc: investorPortal.marketData.mobileImage,
	            sizes: imageSizes
	          })
	        ),
	        _react2.default.createElement(_index6.default, {
	          header: investorPortal.serviceIntegrations.header,
	          text: investorPortal.serviceIntegrations.text,
	          logos: investorPortal.serviceIntegrations.integrationsLogos,
	          imageSizes: imageSizes
	        })
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: _productPageModule2.default.services },
	        _react2.default.createElement(_index2.default, {
	          header: services.sectionHeader.header,
	          subHeader: services.sectionHeader.subHeader,
	          text: services.sectionHeader.text
	        }),
	        _react2.default.createElement(
	          'section',
	          {
	            className: _productPageModule2.default.omsComponents,
	            id: services.omsComponents.id,
	            ref: function ref(omsComponentsSection) {
	              _this2[services.omsComponents.id] = omsComponentsSection;
	            }
	          },
	          _react2.default.createElement(
	            'h2',
	            null,
	            services.omsComponents.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            services.omsComponents.text
	          ),
	          _react2.default.createElement(_index4.default, {
	            to: 'mailto:info@oms.no',
	            text: services.omsComponents.buttonText,
	            outBound: true
	          }),
	          _react2.default.createElement(_images2.default, {
	            alt: services.omsComponents.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: services.omsComponents.desktopImage,
	            tabletSrc: services.omsComponents.tabletImage,
	            mobileSrc: services.omsComponents.mobileImage,
	            sizes: imageSizes
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          {
	            className: _productPageModule2.default.feedAPI,
	            id: services.feedAPI.id,
	            ref: function ref(feedAPISection) {
	              _this2[services.feedAPI.id] = feedAPISection;
	            }
	          },
	          _react2.default.createElement(
	            'h2',
	            null,
	            services.feedAPI.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            services.feedAPI.text
	          ),
	          _react2.default.createElement(_index4.default, {
	            to: 'mailto:info@oms.no',
	            text: services.feedAPI.buttonText,
	            outBound: true
	          }),
	          _react2.default.createElement(_images2.default, {
	            alt: services.feedAPI.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: services.feedAPI.desktopImage,
	            tabletSrc: services.feedAPI.tabletImage,
	            mobileSrc: services.feedAPI.mobileImage,
	            sizes: imageSizes
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: _productPageModule2.default.standardProducts },
	        _react2.default.createElement(_index2.default, {
	          header: standardProducts.sectionHeader.header,
	          subHeader: standardProducts.sectionHeader.subHeader,
	          text: standardProducts.sectionHeader.text
	        }),
	        _react2.default.createElement(
	          'section',
	          {
	            className: _productPageModule2.default.irModules,
	            id: standardProducts.irModules.id,
	            ref: function ref(irModulesSection) {
	              _this2[standardProducts.irModules.id] = irModulesSection;
	            }
	          },
	          _react2.default.createElement(
	            'h2',
	            null,
	            standardProducts.irModules.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            standardProducts.irModules.text
	          ),
	          _react2.default.createElement(_index4.default, {
	            to: 'mailto:info@oms.no',
	            text: standardProducts.irModules.buttonText,
	            outBound: true
	          }),
	          _react2.default.createElement(_images2.default, {
	            alt: standardProducts.irModules.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: standardProducts.irModules.desktopImage,
	            tabletSrc: standardProducts.irModules.tabletImage,
	            mobileSrc: standardProducts.irModules.mobileImage,
	            sizes: imageSizes
	          })
	        ),
	        _react2.default.createElement(
	          'section',
	          {
	            className: _productPageModule2.default.arena,
	            id: standardProducts.arena.id,
	            ref: function ref(arenaSection) {
	              _this2[standardProducts.arena.id] = arenaSection;
	            }
	          },
	          _react2.default.createElement(
	            'h2',
	            null,
	            standardProducts.arena.header
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'bodyLarge' },
	            standardProducts.arena.text
	          ),
	          _react2.default.createElement(_index4.default, {
	            to: 'mailto:info@oms.no',
	            text: standardProducts.arena.buttonText,
	            outBound: true
	          }),
	          _react2.default.createElement(_images2.default, {
	            alt: standardProducts.arena.header,
	            outerWrapperClassName: _productPageModule2.default.imageContainer,
	            desktopSrc: standardProducts.arena.desktopImage,
	            tabletSrc: standardProducts.arena.tabletImage,
	            mobileSrc: standardProducts.arena.mobileImage,
	            sizes: imageSizes
	          })
	        )
	      )
	    );
	  };
	
	  return ProductPageTemplate;
	}(_react.Component);
	
	ProductPageTemplate.propTypes = {
	  linkCardsSection: _propTypes2.default.shape({}),
	  investorPortal: _propTypes2.default.shape({}),
	  standardProducts: _propTypes2.default.shape({}),
	  services: _propTypes2.default.shape({}),
	  imageSizes: _propTypes2.default.arrayOf(_propTypes2.default.object)
	};
	
	
	var ProductPage = function ProductPage(_ref) {
	  var data = _ref.data;
	
	  var page = data.page.frontmatter;
	  var imageSizes = data.imageSizes.edges;
	
	  return _react2.default.createElement(ProductPageTemplate, {
	    linkCardsSection: page.linkCardsSection,
	    investorPortal: page.investorPortal,
	    standardProducts: page.standardProducts,
	    services: page.services,
	    imageSizes: imageSizes
	  });
	};
	
	exports.default = ProductPage;
	
	
	ProductPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	var productPageQuery = exports.productPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"productPage":"src-templates-productPage----productPage-module---productPage---1HDiZ","centered":"src-templates-productPage----productPage-module---centered---cCnAu","linkCardsSection":"src-templates-productPage----productPage-module---linkCardsSection---2s8PT","linkCards":"src-templates-productPage----productPage-module---linkCards---2gID7","investorPortal":"src-templates-productPage----productPage-module---investorPortal---161rt","onlinePortfolio":"src-templates-productPage----productPage-module---onlinePortfolio---poN2x","overline":"src-templates-productPage----productPage-module---overline---1915I","imageContainer":"src-templates-productPage----productPage-module---imageContainer---16m41","trading":"src-templates-productPage----productPage-module---trading---3bhQu","marketData":"src-templates-productPage----productPage-module---marketData---awhBC","standardProducts":"src-templates-productPage----productPage-module---standardProducts---1mtE0","irModules":"src-templates-productPage----productPage-module---irModules---10jA7","arena":"src-templates-productPage----productPage-module---arena---25ucq","services":"src-templates-productPage----productPage-module---services---Lk_Ou","omsComponents":"src-templates-productPage----productPage-module---omsComponents---AnkCZ","feedAPI":"src-templates-productPage----productPage-module---feedAPI---3INye"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-page-index-js-198a1f19c877ec6031b9.js